import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccordeonComponent } from './accordeon.component';
import { AccordeonItemComponent } from './components/accordeon-item/accordeon-item.component';
import { AccordeonItemHeaderComponent } from './components/accordeon-item-header/accordeon-item-header.component';
import { AccordeonItemContentComponent } from './components/accordeon-item-content/accordeon-item-content.component';

@NgModule({
  declarations: [
    AccordeonComponent,
    AccordeonItemComponent,
    AccordeonItemHeaderComponent,
    AccordeonItemContentComponent,
  ],
  imports: [CommonModule],
  exports: [
    AccordeonComponent,
    AccordeonItemComponent,
    AccordeonItemHeaderComponent,
    AccordeonItemContentComponent,
  ],
})
export class AccordeonModule {}
